import { ButtonLink } from "@ui/ButtonLink";
import { AskConsumerLayout } from "@ui/layouts/AskConsumerLayout/AskConsumerLayout";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import { CategoryCreators } from "./components/CategoryCreators";
import { pageVars } from "./utils/pageVars";

export const CategoryApp = () => {
	const vars = pageVars();
	const category = () => vars.category ?? null;

	return (
		<AskConsumerLayout
			title={category()?.name ?? "Category"}
			backLink="/discovery"
			signedOutTopNav
		>
			<div class="askgvt-page askgvt-page--category">
				<Show
					when={category()}
					fallback={
						<>
							<Text as="h1" size="medium-large" weight="semi-bold" color="ink">
								Category not found
							</Text>
							<ButtonLink
								href="/discovery"
								size="small"
								variant="text"
								symbol="arrow_back"
							>
								Back to discovery
							</ButtonLink>
						</>
					}
				>
					{(current) => <CategoryCreators category={current()} />}
				</Show>
			</div>
		</AskConsumerLayout>
	);
};
